import { DEFAULT_GOOD_VIBES_VISIBILITY, type GoodVibesVisibility, GoodVibesVisibilitySchema } from "@domains/good-vibes/shared/goodVibesVisibility.ts";
import { FilterChipSelect } from "@packages/core-client/collection/FilterChipSelect.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { SelectItem } from "@/components/ui/select.tsx";
import { i18NextInstanceKey } from "../i18n/i18next.ts";

export interface GoodVibesVisibilitySelectProps {
    visibility: GoodVibesVisibility;
    onVisibilityChange: (visibility: GoodVibesVisibility) => void;
}

export function GoodVibesVisibilitySelect({ visibility, onVisibilityChange }: GoodVibesVisibilitySelectProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("GoodVibesVisibilitySelect", { i18n: i18nextInstance });

    const handleSelectionChange = useCallback((key: Key) => onVisibilityChange(GoodVibesVisibilitySchema.catch(DEFAULT_GOOD_VIBES_VISIBILITY).parse(key)), [onVisibilityChange]);

    return (
        <FilterChipSelect ariaLabel={t("ariaLabel")} clearAriaLabel={t("clearAriaLabel")} selectedKey={visibility} defaultKey={DEFAULT_GOOD_VIBES_VISIBILITY} onSelectionChange={handleSelectionChange} prefix={t("triggerPrefix")}>
            {GoodVibesVisibilitySchema.options.map(value => (
                <SelectItem key={value} id={value} textValue={t(`visibilities.${value}`)}>
                    {t(`visibilities.${value}`)}
                </SelectItem>
            ))}
        </FilterChipSelect>
    );
}
